import { IconProps } from 'components/Shared/Icon';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

// tslint:disable: max-line-length
export const IconSearch = (props: IconProps) => (
  <svg
    className={iconStyles(props)}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.03512 11.2549H5.24512L0.255117 16.2549L1.74512 17.7449L6.74512 12.7549V11.9649L7.01512 11.6849C8.15512 12.6649 9.63512 13.2549 11.2451 13.2549C14.8351 13.2549 17.7451 10.3449 17.7451 6.75488C17.7451 3.16488 14.8351 0.254883 11.2451 0.254883C7.65512 0.254883 4.74512 3.16488 4.74512 6.75488C4.74512 8.36488 5.33512 9.84488 6.31512 10.9849L6.03512 11.2549ZM15.7451 6.75488C15.7451 9.24488 13.7351 11.2549 11.2451 11.2549C8.75512 11.2549 6.74512 9.24488 6.74512 6.75488C6.74512 4.26488 8.75512 2.25488 11.2451 2.25488C13.7351 2.25488 15.7451 4.26488 15.7451 6.75488Z"
      stroke="none"
    />
  </svg>
);
